import { Box, Modal, Paper, Typography } from "@mui/material";
import { Colors } from "./Colors";
import { Info, Warning } from "@mui/icons-material";
import { Ref } from "react";
import { WarningMessage } from "./VideoPlayer";

import React from "react";

export default function InfoModal({
  message
}: {
  message: WarningMessage;
}) {
  return (
    <Paper
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: 2,
        backgroundColor: Colors.bgGray,
        width: 400,
        height: 300,
        borderRadius: 2,
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        justifyItems: "center",
      }}
    >
      <Info color="secondary" sx={{ fontSize: 40 }} />
      <Typography variant="h6" fontWeight={"bold"}>
        {message ? message.title : "No Title"}
      </Typography>
      <Typography variant="body1">{message ? message.message : "No Message"}</Typography>
    </Paper>
  );
}
